import type { Vendor } from '../types';

export const vendors: Vendor[] = [
  {
    id: 'v1',
    name: '오드리드레스',
    category: 'dress',
    region: '강남/신사',
    priceRange: '250~350만원',
    reviewCount: 142,
    photoReviewCount: 89,
    matchRate: 94,
    image: 'https://images.unsplash.com/photo-1594552072238-b8a33785b261?w=400&h=500&fit=crop',
    tags: ['내 예산과 맞음', '후기 사진 많음', '상담 만족도 높음', '본식 퀄리티 언급 많음'],
    recommendReason: '반수제 예복 중 가성비 최고로 평가받는 업체. 본식 퀄리티와 상담 친절도가 높게 나타남.',
  },
  {
    id: 'v2',
    name: '블랑누보',
    category: 'dress',
    region: '청담/압구정',
    priceRange: '400~600만원',
    reviewCount: 89,
    photoReviewCount: 56,
    matchRate: 88,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&h=500&fit=crop',
    tags: ['본식 퀄리티 언급 많음', '수제 정장 전문', '피팅 서비스 우수'],
    recommendReason: '수제 정장 전문으로 핏 교정과 수선 서비스가 탁월. 고가대지만 퀄리티로 만족도 높음.',
  },
  {
    id: 'v3',
    name: '쏘로우샵',
    category: 'dress',
    region: '홍대/합정',
    priceRange: '150~220만원',
    reviewCount: 267,
    photoReviewCount: 198,
    matchRate: 91,
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=500&fit=crop',
    tags: ['후기 사진 많음', '가성비 갑', '대여+구매 복합 가능'],
    recommendReason: '촬영+본식 대여 패키지로 합리적. 후기 사진이 가장 많아 실제 결과물 확인 가능.',
  },
  {
    id: 'v4',
    name: '스톤헨지',
    category: 'jewelry',
    region: '강남/잠실',
    priceRange: '300~500만원',
    reviewCount: 203,
    photoReviewCount: 134,
    matchRate: 92,
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=500&fit=crop',
    tags: ['내 예산과 맞음', '브랜드 인증서 제공', 'A/S 조건 우수', '상담 투명성 높음'],
    recommendReason: '브랜드 공식 매장으로 보증서와 A/S가 확실. 상담 시 다이아 등급 공개가 투명함.',
  },
  {
    id: 'v5',
    name: '클라우드링',
    category: 'jewelry',
    region: '성수/서울숲',
    priceRange: '180~350만원',
    reviewCount: 156,
    photoReviewCount: 112,
    matchRate: 89,
    image: 'https://images.unsplash.com/photo-1603561591411-07134e71a2a9?w=400&h=500&fit=crop',
    tags: ['공방 직접 제작', '커스텀 디자인 가능', '가격대 다양'],
    recommendReason: '커플링 공방으로 직접 디자인 참여 가능. 다이아 외 보석 선택 폭이 넓음.',
  },
  {
    id: 'v6',
    name: '로이드',
    category: 'jewelry',
    region: '전국 백화점',
    priceRange: '100~250만원',
    reviewCount: 312,
    photoReviewCount: 245,
    matchRate: 85,
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=500&fit=crop',
    tags: ['브랜드 신뢰도 높음', '백화점 A/S', '가격대 친화적'],
    recommendReason: '전국 백화점에서 A/S가 가능해 지방 고객에게도 적합. 입문용 커플링으로 추천.',
  },
  {
    id: 'v7',
    name: '한복나래',
    category: 'hanbok',
    region: '종로/인사동',
    priceRange: '80~200만원',
    reviewCount: 178,
    photoReviewCount: 143,
    matchRate: 93,
    image: 'https://images.unsplash.com/photo-1545959828-0c33292a0b20?w=400&h=500&fit=crop',
    tags: ['혼주 한복 포함', '대여+맞춤 동시 가능', '후기 사진 많음', '피팅 일정 유연'],
    recommendReason: '신랑신부+양가 혼주 세트로 예약 가능. 대여와 맞춤 선택이 자유롭고 피팅 일정이 유연.',
  },
  {
    id: 'v8',
    name: '청현재의',
    category: 'hanbok',
    region: '압구정/청담',
    priceRange: '150~400만원',
    reviewCount: 98,
    photoReviewCount: 72,
    matchRate: 87,
    image: 'https://images.unsplash.com/photo-1566408668744-18907a91ee3b?w=400&h=500&fit=crop',
    tags: ['맞춤 한복 전문', '고급 원단 사용', '디자인 감각 우수'],
    recommendReason: '맞춤 한복 전문으로 원단 품질과 디자인 감각이 뛰어남. 현대적 해석을 더한 디자인.',
  },
  {
    id: 'v9',
    name: '현대한복',
    category: 'hanbok',
    region: '전국 대여 가능',
    priceRange: '50~120만원',
    reviewCount: 245,
    photoReviewCount: 189,
    matchRate: 90,
    image: 'https://images.unsplash.com/photo-1588691569972-260459ab5c3e?w=400&h=500&fit=crop',
    tags: ['전국 배송 대여', '가격대 친화적', '반납 조건 간편'],
    recommendReason: '전국 배송 대여로 지방에서도 이용 가능. 반납 택배 서비스로 준비 부담이 적음.',
  },
];